import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AgmCoreModule } from '@agm/core';

import { ContactusComponent } from './contactus.component';

@NgModule({
  declarations: [
    ContactusComponent
  ],
  imports:[BrowserModule,
  	AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDOV1D2EyqWcOJ-dT1gx6VJK4F75hawVSA'
    })
  ],
  exports:[ContactusComponent],
  providers: [],
})
export class ContactusModule { }



// WEBPACK FOOTER //
// ./src/app/contact_us/contactus.module.ts